module.exports = __webpack_public_path__ + "img/dpin_question_creation.e771ea3f.png";